import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";

export const useSitesBySiteIds = (siteIds: string[]) => {
  const { siteBySiteId } = useSnapshot(sitesPipelineStore);

  return siteIds.map((siteId) => siteBySiteId[siteId]);
};
